<template>
  <v-row>
    <v-col>
      <v-row
        class="height-25 mx-2 mb-4 font-size-medium-large font-weight-medium"
      >
        Notification Performance Reports
      </v-row>
      <v-row class="mx-2">
        <v-col cols="6" class="pa-4">
          <v-row>
            <v-data-table
              style="flex-grow: 1"
              :sort-by="'time_sent'" 
              :sort-desc="true"
              :headers="[
                { text: 'Actions', value: 'buttons', sortable: false },
                { text: 'Title', value: 'title' },
                {
                  text: 'Scheduled time',
                  value: 'time_scheduled',
                },
              ]"
              :items="notificationPerformanceReportItems"
              :items-per-page="10"
            >
              <template v-slot:header.buttons="{ header }">
                <span>{{ header.text }}</span>
                <v-tooltip bottom max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon color="grey lighten-1" size="20">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Notifications cannot be deleted within<br />
                    30 seconds of it's scheduled time.
                  </span>
                </v-tooltip>
              </template>

              <template v-slot:item.title="{ item }">
                <span
                  :class="{
                    'text-decoration-line-through':
                      item.action.invocations.deleted,
                  }"
                >
                  {{ item.title }}
                </span>
              </template>
              <template v-slot:item.time_scheduled="{ item }">
                {{ formatEpoch(item.time_scheduled) }}
              </template>
              <template v-slot:item.buttons="{ item, index }">
                <span class="d-flex">
                  <v-btn
                    @click="selectedAction = item"
                    :disabled="
                      selectedAction
                        ? item.action_id === selectedAction.action_id
                        : false
                    "
                  >
                    View <v-icon small>mdi-arrow-right</v-icon>
                  </v-btn>
                  <delete-notification-modal
                    v-if="displayDeleteNotification(item, index)"
                    :ref="`delete-notification-modal-${index}`"
                    :notification="item"
                  />
                </span>
              </template>
            </v-data-table>
          </v-row>
        </v-col>
        <v-col cols="6" class="pa-4">
          <notification-performance-report
            v-if="selectedAction"
            :action="selectedAction"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import { parseISO, endOfToday, format } from 'date-fns';
  import NotificationPerformanceReport from '@/components/Reports/NotificationPerformanceReport';
  import CvcCard from '@/components/CvcCard';
  import DeleteNotificationModal from '@/components/Notifications/DeleteNotificationModal';

  export default {
    name: 'NotificationsReporting',
    components: {
      DeleteNotificationModal,
      CvcCard,
      NotificationPerformanceReport,
    },
    data: () => ({
      today: null,
      castIcon: require('@/assets/cast.png'),
      selectedAction: null,
      deleteNotificationTimeouts: new Array(10).fill(null),
    }),
    created() {
      this.today = endOfToday();
    },
    computed: {
      notificationPerformanceReportItems() {
        if (!this.$store.state.notifications.profileActionResponsesData)
          return [];
        const profileActionResponsesData = this.$store.state.notifications
          .profileActionResponsesData;

        let ret = [];
        profileActionResponsesData.forEach((profile) => {
          profile.actions.forEach((action) => {
            ret = ret.concat(action);
          });
        });

        ret.sort((action1, action2) =>
          action1.action_id.localeCompare(action2.action_id)
        );

        return ret.map((x) => ({
          ...x,
          title: x.action.action.payload.title,
          time_scheduled: x.action?.action?.args?.absolute?.$date ?? 'Unknown',
        }));
      },
    },
    methods: {
      formatTimestamp(ts) {
        return format(parseISO(ts), 'yyyy-MM-dd HH:mm');
      },
      formatEpoch(ms) {
        return format(ms, 'yyyy-MM-dd HH:mm');
      },
      displayDeleteNotification(item, index) {
        if (this.deleteNotificationTimeouts[index] !== null) {
          clearTimeout(this.deleteNotificationTimeouts[index]);
          this.deleteNotificationTimeouts[index] = null;
        }

        if (item.action.invocations.deleted) {
          return false;
        }
        
        // This function decides if we can delete this notification => only applicable to AbsoluteCalendarNotifications
        if (item.action.action.type !== 'AbsoluteCalendarNotification') {
          return false;
        }

        const deadline = new Date().getTime() + 30000; // 30 seconds
        const actionTime = item.action.action.args.absolute.$date;
        if (actionTime <= deadline) {
          return false;
        }

        if (actionTime - deadline <= 24 * 60 * 60 * 1000) {
          this.deleteNotificationTimeouts[index] = setTimeout(
            () => this.disableDeleteNotification(index),
            actionTime - deadline
          );
        }
        return true;
      },
      disableDeleteNotification(index) {
        const toHide = this.$refs[`delete-notification-modal-${index}`];
        if (toHide) {
          toHide.hideDialogForNotification();
          toHide.disableButton();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/_mixins.scss';

  .notifications-reporting-wrapper {
    background-color: #f7f7fc;
    margin: 0;
    padding: 40px;
    height: 814px;
  }
</style>
